import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  buttonsGroup: {
    width: "100%"
  },
  buttonsGroupItem: {
    "& .MuiButtonBase-root": {
      height: 35,
      backgroundColor: "inherit"
    }
  },
  button: {
    height: 35,
    maxHeight: 35
  },
  hidden: {
    display: "none"
  }
}));
